// extracted by mini-css-extract-plugin
module.exports = {"popup":"AdvDetailedPopup_popup__A86X3","description":"AdvDetailedPopup_description__EzgDR","button":"AdvDetailedPopup_button__XY6_Q"};